var map = {
	"./avatar-s-1.png": "26ff",
	"./avatar-s-10.png": "040a",
	"./avatar-s-11.png": "ce9f",
	"./avatar-s-12.png": "9872",
	"./avatar-s-13.png": "7153",
	"./avatar-s-14.png": "eb36",
	"./avatar-s-15.png": "71a4",
	"./avatar-s-16.png": "42b1",
	"./avatar-s-17.png": "60ff",
	"./avatar-s-18.png": "db71",
	"./avatar-s-19.png": "98bf",
	"./avatar-s-2.png": "b054",
	"./avatar-s-20.png": "6302",
	"./avatar-s-21.png": "c7cc",
	"./avatar-s-22.png": "915d",
	"./avatar-s-23.png": "b2fc",
	"./avatar-s-24.png": "dba0",
	"./avatar-s-25.png": "7613",
	"./avatar-s-26.png": "d76a",
	"./avatar-s-3.png": "5c35",
	"./avatar-s-4.png": "d864c",
	"./avatar-s-5.png": "8002",
	"./avatar-s-6.png": "fd76",
	"./avatar-s-7.png": "1eb1",
	"./avatar-s-8.png": "126e",
	"./avatar-s-9.png": "fdf2",
	"./avatar.png": "7966"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60db";